export const languageStringsAdmin = {
  title: "Clients",
  pricingPeriod: {
    monthly: "Monthly",
    yearly: "Yearly",
  },
  table: {
    email: "Email",
    fullName: "Full name",
    accountType: "Account type",
    websites: "Websites",
    campaigns: "Campaigns",
    subscription: "Subscription",
    takeControl: "Take control",
    loginButton: "Log in",
    noSubscription: "-------",
  },
  tools: {
    button: "Admin Tools",
    modalTitle: "Admin Tools",
    title: "Admin Tools",
    clearCache: "Clear Cache",
    error: "Error performing action",
    clearGoogleReviewsCache: {
      title: "Clear Google Reviews Cache",
      description:
        "Clear all cached Google Reviews data for all websites. Reviews will be re-fetched on next request in the language configured for each website.",
      success: "Google Reviews cache cleared successfully",
    },
  },
  errorLogs: {
    button: "Error logs",
    title: "Error logs (frontend)",
    empty: "No errors logged.",
  },
};
